export default "__VITE_ASSET__3e4f4f8e__"